import React from 'react';
import PropTypes from 'prop-types';
import Slider from 'rc-slider';
import theme from 'lib/theme';

const PointsPaySlider = ({ cashAmount, initialCashAmount, maxCashAmount, minCashAmount, onChange }) => (
  <Slider
    min={minCashAmount}
    max={maxCashAmount}
    defaultValue={initialCashAmount}
    value={cashAmount}
    onChange={onChange}
    step={0.01}
    railStyle={theme.slider.rail}
    trackStyle={theme.slider.track}
    handleStyle={theme.slider.handle}
    ariaLabelForHandle="Use Qantas Points and cash"
  />
);

PointsPaySlider.propTypes = {
  cashAmount: PropTypes.number,
  initialCashAmount: PropTypes.number.isRequired,
  maxCashAmount: PropTypes.number.isRequired,
  minCashAmount: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PointsPaySlider;
